export const getPriceKey = (packageId) => `floor_plan_${packageId}_price`;
